import { connect } from 'react-redux';

import { mark, reset } from './actions';

export default function withGuard(Component) {
  const Guarded = connect(
    ({ changeGuard }) => ({ modified: changeGuard }),
    { reset, mark },
    ({ modified }, dispatchProps, ownProps) => ({
      guard: { modified, ...dispatchProps },
      ...ownProps,
    }),
  )(Component);

  Guarded.displayName = `withGuard(${Component.displayName || Component.name})`;

  return Guarded;
}
